import { render, staticRenderFns } from "./DadosCadastroEmpresa.vue?vue&type=template&id=715ff6e9&scoped=true&"
import script from "./DadosCadastroEmpresa.vue?vue&type=script&lang=js&"
export * from "./DadosCadastroEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./DadosCadastroEmpresa.vue?vue&type=style&index=0&id=715ff6e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ff6e9",
  null
  
)

export default component.exports